module.exports = "/_next/static/videos/adeptVideo-dark-9b9361efc1e34078b15864dd38f2e26c.mp4";